import React from "react"
import PropTypes from "prop-types"
import { Route, Redirect } from "react-router-dom"
import ErrorBoundary from "../../components/Common/ErrorBoundary"

const Authmiddleware = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  ...rest
}) => (
  <Route
    {...rest}
    render={props => {
      if (isAuthProtected && !localStorage.getItem("authUser")) {

        return (
          <Redirect
            to={{ pathname: "/login", state: { from: props.location } }}
          />
        )
      }

      return (
        <Layout>
          {/* El `key` es imprescindible: sin el, el boundary queda montado en
              estado de error y el usuario no sale del fallback ni navegando. */}
          <ErrorBoundary variant="page" key={props.location.pathname}>
            <Component {...props} />
          </ErrorBoundary>
        </Layout>
      )
    }}
  />
)

Authmiddleware.propTypes = {
  isAuthProtected: PropTypes.bool,
  component: PropTypes.any,
  location: PropTypes.object,
  layout: PropTypes.any,
}

export default Authmiddleware;
